var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "landing-cnt row" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "col-12 d-landscape-none d-xl-none d-lg-flex main-block-xs my-auto"
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "d-block d-lg-none my-auto text-ctn-embedded pt-5 pt-lg-0"
              },
              [
                _c("h1", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("patients-landing.mobile-title"))
                  }
                }),
                _vm._v(" "),
                _c("h1", { staticClass: "embedded-title" }, [
                  _vm._v(_vm._s(_vm.$t("patients-landing.mobile-title-2")))
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "text-block-ctn col-desktop-6 col-xl-6 col-landscape-6 col-12 d-flex my-auto pt-0 pt-lg-5"
          },
          [
            _c(
              "div",
              { staticClass: "text-ctn m-auto mx-sm-0 w-100 mb-3 mb-lg-0" },
              [
                _c("div", { staticClass: "d-none d-lg-block my-auto" }, [
                  _c("h1", {
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("patients-landing.mobile-title"))
                    }
                  }),
                  _vm._v(" "),
                  _c("h1", { staticClass: "embedded-title" }, [
                    _vm._v(_vm._s(_vm.$t("patients-landing.mobile-title-2")))
                  ])
                ]),
                _vm._v(" "),
                _c("SimpleSearch")
              ],
              1
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("BlueCenteredBlock", {
        staticClass: "blue-block",
        attrs: {
          title: _vm.$t("patients-landing.different-health"),
          subtitle: _vm.$t("patients-landing-different-health-description")
        }
      }),
      _vm._v(" "),
      _c("Blocks2x2Section", {
        staticClass: "my-5",
        attrs: { title: _vm.$t("patients-landing.why-opensalud-different") }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "page" }, [
        _c("div", {
          staticClass: "content-page d-none d-lg-block",
          attrs: { id: "profesional" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "content-page", attrs: { id: "black" } }, [
          _c("div", { staticClass: "wrap-content" }, [
            _c("h4", { staticClass: "title white" }, [
              _vm._v(
                _vm._s(_vm.$t("patients-landing.independent-professionals"))
              )
            ]),
            _vm._v(" "),
            _c("h5", { staticClass: "subtitle white" }, [
              _vm._v(_vm._s(_vm.$t("patients-landing.quality-medicine")))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "paragraph grey" }, [
              _vm._v(_vm._s(_vm.$t("patients-landing.sign-up-banner")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "wrap-buttons" }, [
              _c("div", { staticClass: "first-button" }, [
                _c(
                  "button",
                  {
                    staticClass: "item-button white-lineal",
                    attrs: { target: "_blank" },
                    on: {
                      click: function() {
                        _vm.$router.push("/inicio-sesion")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("patients-landing.know-more")))]
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("patients-landing-swiper", {
        attrs: { title: _vm.$t("patients-landing.swiper.title") }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-5 pb-5 mx-auto text-center" },
        [
          _c(
            "base-button",
            {
              staticClass: "mt-4",
              attrs: { variant: "secondary" },
              on: {
                click: function($event) {
                  return _vm.$router.push("/inicio-sesion")
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("patients-landing.sign-up-free")))]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "menttum-container" }, [
        _c("div", { staticClass: "content" }, [
          _c("h4", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("patients-landing.opensalud360-title")))
          ]),
          _vm._v(" "),
          _c("h5", { staticClass: "subtitle blue" }, [
            _vm._v(_vm._s(_vm.$t("patients-landing.opensalud360-subtitle")))
          ]),
          _vm._v(" "),
          _c("p", {
            staticClass: "paragraph",
            domProps: {
              innerHTML: _vm._s(_vm.$t("patients-landing.opensalud360-text"))
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "wrap-buttons" }, [
            _c("div", { staticClass: "first-button" }, [
              _c(
                "button",
                {
                  staticClass: "item-button white-solid",
                  attrs: { target: "_blank" },
                  on: {
                    click: function() {
                      _vm.$router.push("/opensalud360/empresas")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("patients-landing.know-more")))]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _vm._m(1)
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bg-image" }, [_c("div")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "image-container" }, [_c("div")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7fd08b55", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fd08b55","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/opensalud/Pacientes.vue
// module id = 4380
// module chunks = 49